import { useTheme } from '@mui/material/styles';
import { baseMui, cudaLight } from '../styles/bdstokens/index';
const useTokens = () => {
    const theme = useTheme();
    const tokens = theme.custom.identifier === 'cudaLight' ? cudaLight : baseMui;
    return tokens;
};
export default useTokens;
//# sourceMappingURL=useTokens.js.map